'use strict';

exports.__esModule = true;
exports.SideNavigation = exports.Header = undefined;

var _Header = require('./header/Header');

var _Header2 = _interopRequireDefault(_Header);

var _SideNavigation = require('./sideNavigation/SideNavigation');

var _SideNavigation2 = _interopRequireDefault(_SideNavigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This file groups all components in one place so it will be easy to imports
 * them in any view
 */
exports.Header = _Header2.default;
exports.SideNavigation = _SideNavigation2.default;